import React, { Component } from "react";
import { controls } from '../../pages/controls';
import AutoComponent from "../common/AutoComponent";
import { Table, UncontrolledTooltip, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { domainFunctions } from "../oro-module/domainFunctions";


import moment from 'moment';
import { FaCheck } from "react-icons/fa";
import { MdClose, MdArrowDropDownCircle } from "react-icons/md";
import { currencyCommas, sentenceCase, toTitleCase, camelCase, toDate, RelevantIcon, currencyNonCommas } from "../oro-module/commonFunctions";

// FaCheck
const styles = {
  requiredFields: {
    backgroundColor: "white",
    color: "black",
    border: "1px solid gold",
    textAlign: "left"
  },
};

function copyArrayObject(arr) {
  let newarr = [];
  arr.map(obj => newarr.push({ ...obj }));
  return newarr;
}

function deepEquality(obj1, obj2) {
  let equality = true; let a;
  if (obj1.length == obj2.length) {
    obj1.map((row, idx) => {
      !Object.is(row, obj2[idx]) ? equality = false : a = 1;
    })
  } else {
    equality = false;
  }
  return equality;
}

function toCurrency(val) {
  // Convert 123456 to 1,23,456.00
  // var x=125465778;
  let [rupees, paise] = String(val).split(".");
  let res = rupees.toString().replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  if (paise) {
    res += "." + paise;
  } else {
    res += ".00";
  }
  // let av=String(val).split(".");
  return res;
}


const URL = ({ title, url }) => {
  return <span className="hand underline" style={{ color: "blue" }} onClick={() => window.open(url)}>{title}</span>
}

function convertBoxValues(boxvalue, displaytype, current) {

  if (!boxvalue) {
    boxvalue = "";
  }
  if (displaytype == 'currency') {
    boxvalue = currencyCommas(boxvalue)
  }
  else if (displaytype == 'scurrency') {
    boxvalue = currencyNonCommas(boxvalue)
  }
  else if (displaytype == 'date') {
    boxvalue = boxvalue ? toDate(boxvalue) : "";
  } else if (displaytype == 'capital') {
    boxvalue = boxvalue.toUpperCase()
  } else if (displaytype == 'small') {
    boxvalue = boxvalue.toLowerCase();
  } else if (displaytype == 'sentencecase') {
    boxvalue = sentenceCase(boxvalue)
  } else if (displaytype == 'titlecase') {
    boxvalue = toTitleCase(boxvalue)
  } else if (displaytype == 'camelcase') {
    boxvalue = camelCase(boxvalue)
  } else if (displaytype == 'yesno') {
    boxvalue = (boxvalue && boxvalue != "") ? "YES" : "NO";
  } else if (displaytype == 'tick') {
    boxvalue = (boxvalue && boxvalue != "") ? <FaCheck style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644" }} /> : <MdClose style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644", fontWeight: "bold" }} />;
  } else if (displaytype == 'link') {
    if (boxvalue) {
      let { remoteip } = current.props.parentState;
      let url = `${remoteip}/file/${boxvalue}`;
      let tit = boxvalue.split("_");
      let title = tit.slice(1, tit.length).join("_");
      boxvalue = <URL title={title} url={url} />;
    }
  } else if (displaytype == 'file') {
    if (boxvalue) {
      if (boxvalue.indexOf('http') != -1) {
        boxvalue = <URL title="File" url={boxvalue} />;
      } else {
        let { remoteip } = current.props.parentState;
        let ur = `${remoteip}/file/${boxvalue}`;
        boxvalue = <URL title="File" url={ur} />;
      }
    }
  }

  return boxvalue;
}

class HtmlTableCustom extends Component {
  constructor(props) {
    super(props);
    this.state = { editing: {}, copying: {}, deleting: {}, val: "", popoverOpen: false };
  }

  shouldComponentUpdate(prevProps, prevState) {
    // Limit re-running of the onRender functions.
    let shouldProceed = true;
    let { component, parentState } = this.props;
    let { name } = component;
    let { pageData, openmodals } = parentState;
    let currentVal = "";
    let prevVal = this.state.val;
    let current = this;
    let modalname = openmodals[openmodals.length - 1];
    if (modalname && pageData[modalname]) {
      currentVal = pageData[modalname][name];
    } else {
      currentVal = pageData[name];
    }

    //  
    if (currentVal && JSON.stringify(currentVal) != prevVal) {
      // //   let cv=copyArrayObject(currentVal);
      this.setState({ val: JSON.stringify(currentVal) });

      // do the on render calculations
      if (component.onRender) {
        // console.log("component.onRender")
        let allResults = {};
        component.onRender.map(func => {
          let { calcType, inputs, resultVar } = func;
          allResults[resultVar] = domainFunctions[func.f]({ parentState, calcType, inputs, allResults, current });
        });
        // console.log(allResults)
      }

    }
    return shouldProceed;
  }

  handletoggledropdown = () => {
    let { popoverOpen } = this.state
    this.setState({ popoverOpen: !popoverOpen })
  }

  // handleButtons = () =>{

  // }

  handleCopy = (index, tableData) => {
    // populate pageData fields.
    let { pageData } = this.props.parentState;
    let { tableHeaders } = this.props.component;
    let proceed = true; let pending = []; let cnt = 1;
    tableHeaders.map(col => {
      let existing = pageData[col.field];
      if (existing && existing != "") {
        let nn = toTitleCase(cnt + ". " + col.field.replace("_", ' '));
        pending.push(nn);
        proceed = false;
        cnt += 1;
      }
    });

    if (proceed) {
      tableHeaders.map(col => {
        // Check if this should be focused & blurred?
        if (col.field) {
          this.props.liftState({ name: col.field }, tableData[index][col.field]);
        }
      });
      // this.handleConfirmDelete(index, tableData);
    } else {
      alert("Already editing. Please clear\n" + pending.join('\n'));
    }
  }

  handleEdit = (index, tableData) => {
    // populate pageData fields.
    let { pageData } = this.props.parentState;
    let { tableHeaders } = this.props.component;
    let proceed = true; let pending = []; let cnt = 1;
    let unq = "";
    tableHeaders.map(col => {
      let existing = pageData[col.field];
      if (existing && existing != "") {
        let nn = toTitleCase(cnt + ". " + col.field.replace("_", ' '));
        pending.push(nn);
        proceed = false;
        cnt += 1;
      }
    });
    // if (proceed) {
    tableHeaders.map(col => {
      // Check if this should be focused & blurred?
      if (col.field) {
        this.props.liftState({ name: col.field }, tableData[index][col.field]);
        unq += col.field;
        if (col.field.indexOf("_display") != -1) {
          this.props.liftState({ name: col.field.replace("_display", "_uid") }, tableData[index][col.field.replace("_display", "_uid")]);
        }
      }
    });
    let unique_id = tableData[index]["unique_id"];
    if (unique_id) {
      this.props.liftGlobalState({ name: unq }, unique_id);
    }

    this.handleConfirmDelete(index, tableData);
    // } else {
    //   alert("Already editing. Please clear\n" + pending.join('\n'));
    // }

    // let { editing } = this.state;
    // editing[index] = true;
    // this.setState({ editing });
  }

  handleDelete = (index) => {
    let { deleting } = this.state;
    deleting[index] = true;
    this.setState({ deleting });
  }

  handleCancelEdit = (index) => {
    let { editing } = this.state;
    delete editing[index];
    this.setState({ editing });
  }

  handleCancelDelete = (index) => {
    let { deleting } = this.state;
    delete deleting[index];
    this.setState({ deleting });
  }

  handleConfirmDelete = (index, tableData) => {
    let { deleting } = this.state;
    delete deleting[index];
    this.setState({ deleting });

    const { tableTitle, tableHeaders, name, displaytype, toggledropdown, editable, deletable } = this.props.component;
    let { pageData, fileFolder, formState, openmodals, modalname } = this.props.parentState;
    let compname;
    modalname ? compname = modalname + "." + name : compname = name;
    tableData.splice(index, 1);
    this.props.liftState({ name: compname }, tableData);

    let { editing } = this.state;
    let editing2 = { ...editing }
    for (var key in editing) {
      if (key >= index) {
        delete editing2[key];
        editing2[key - 1] = true;
      }
    }
    this.setState({ editing: editing2 });
  }

  handleAddRows = (tableData) => {

    const { tableTitle, tableHeaders, name, displaytype, editable } = this.props.component;
    let { pageData, fileFolder, formState, openmodals, modalname } = this.props.parentState;
    // let compname;
    // modalname ? compname = name : compname = name;
    let row = {};
    tableHeaders.map(({ field }) => {
      if (field) {
        row[field] = '';
      }
    });

    tableData.push(row);
    this.props.liftState({ name }, tableData);
  }

  liftTableState = (componentInfo, stateValue) => {
    const { tableTitle, tableHeaders, name, displaytype, editable } = this.props.component;
    let { pageData, fileFolder, formState, openmodals, modalname } = this.props.parentState;
    let tableData;
    if (modalname && pageData[modalname]) {
      tableData = pageData[modalname][name]
        ? pageData[modalname][name]
        : [];
    } else {
      tableData = pageData[name]
        ? pageData[name]
        : [];
    }

    // To avoid clearing data on focus of the commoncontrol
    if (!(componentInfo instanceof Array)) {
      let [varname, rownum, field] = componentInfo.name.split(".");
      // console.log({ varname, rownum, field, tableData });
      // To avaoid setting display_data such as guid, display_name etc.
      if (rownum) {
        tableData[parseInt(rownum)][field] = stateValue;
        this.props.liftState(this.props.component, tableData);
      }
    }
  }

  getTableComponent = ({ th, index, curval, rowid, search }) => {
    // val = curval, name = row_index+column_name i.e. rowid+th.field
    const { name } = this.props.component;

    if (th.control) {
      let component = { ...controls[th.control]()[0] };
      component.name = name + "." + rowid + "." + th.field; //Deposits.intsche_table.0.trdate
      return <AutoComponent
        component={component}
        liftState={this.props.liftState}
        liftGlobalState={this.props.liftGlobalState}
        // parentStateGlobal={this.props.parentState}
        parentState={this.props.parentState}
        parentProps={this.props.parentProps}
        key={index}
        index={index}
      />
    } else {
      return <span>Un editable</span>
    }
  }

  componentDidMount() {
    // If default values exist && pageData==[], then set pageData = defaultValues.

  }




  render() {
    let { tableTitle, tableHeaders, name, displaytype, toggledropdown, togglebutton, editable, copyable, deletable, addRows, printable, widths, height, tab } = this.props.component;

    let { pageData, fileFolder, formState, openmodals, modalname, LocalVars } = this.props.parentState;
    let { confirmState } = LocalVars;
    const { forms } = this.props.parentProps.parentState.profile;

    // const tableData = this.props.parentState.pageData[name];
    let tableData;
    // let modalname = openmodals[openmodals.length - 1];
    if (modalname && pageData[modalname]) {
      tableData = pageData[modalname][name]
        ? pageData[modalname][name]
        : [];
    } else {
      tableData = pageData[name]
        ? pageData[name]
        : [];
    }


    if (name == 'probable_matches') {
      let { code, label } = this.props.parentState.LocalVars.selectedTourBranch;
      // Check whether code/label is present in the specified column.
      console.log(code)
      console.log(label)
      let new_data = [];
      tableData.map(table_row => {
        if (table_row['school_name'] == label) { // or label
          new_data.push(table_row);
        }
      })
      tableData = new_data; // This MUST contain at LEAST one record from the own school.
    }


    // console.log({tableData})
    let searchable = "";
    // console.log({ tableData })
    if (pageData.actionbuttons) {
      editable = false;
      copyable = false;
      deletable = false;
    }

    // check the actions to which this user has access to for form {tab}.
    if (forms['2']) { }
    else {
      if (forms[tab] && forms[tab].can_delete) {
        deletable = true;
      } else {
        deletable = false;
      }
    }

    return (
      <div className={`nopadding ${widths.parent ? widths.parent : "col-sm-12"}`} >
        <h2>{tableTitle}</h2>
        <div className="" style={{ paddingLeft: 15, maxHeight: height ? height : 500, overflow: "scroll" }}>
          <Table striped size="sm">
            <thead style={{ fontSize: "15px" }}>
              <tr>
                {/* {toggledropdown && <th>ListButton</th>} */}
                {editable && <th className="tablehead">{!deletable ? "View" : "Edit"}</th>}
                {copyable && <th className="tablehead">Copy</th>}
                {deletable && <th className="tablehead">Delete</th>}
                {/* <RelevantIcon icon="cross"/> */}

                {tableHeaders.map((th, idx) => {
                  if (!th.display || th.display != "none") {
                    if (!th.showOnUpdateOnly || (th.showOnUpdateOnly && pageData.unique_id)) {
                      return <th className="tablehead" key={idx} width={th.width}>{th.label}</th>
                    }
                  }
                }
                )}
              </tr>
            </thead>
            <tbody>{/* Loop for searchable. If true, then display text box. */}
              <tr>
              </tr>

              {tableData && tableData.length > 0 &&
                tableData.map((row, index) => (


                  <tr key={index}>

                    {this.state.editing[index] &&
                      <td style={{ fontSize: 15, padding: 0 }} colSpan="2" onClick={() => this.handleCancelEdit(index)} className="hand underline">Close</td>}

                    {!confirmState && editable && !this.state.editing[index] && !this.state.copying[index] && !this.state.deleting[index] &&
                      <td style={{ fontSize: 15, padding: 0 }} onClick={() => !deletable ? false : this.handleEdit(index, tableData)} className="hand underline">{!deletable ? "View" : "Edit"}</td>}

                    {copyable && !this.state.copying[index] && !this.state.editing[index] && !this.state.deleting[index] &&
                      <td style={{ fontSize: 15, padding: 0 }} onClick={() => this.handleCopy(index, tableData)} className="hand underline">Copy</td>}

                    {!confirmState && deletable && !this.state.editing[index] && !this.state.copying[index] && !this.state.deleting[index] &&
                      <td style={{ fontSize: 15, padding: 0 }} onClick={() => this.handleDelete(index)} className="hand underline">Delete</td>}

                    {this.state.deleting[index] &&
                      <td style={{ fontSize: 15, padding: 0, color: "#990000" }} colSpan="1" onClick={() => this.handleConfirmDelete(index, tableData)} className="hand underline">Yes</td>}
                    {this.state.deleting[index] &&
                      <td style={{ fontSize: 15, padding: 0, color: "green" }} colSpan="1" onClick={() => this.handleCancelDelete(index)} className="hand underline">Cancel</td>}


                    {tableHeaders.map((th, idx) => {
                      if (!th.display || th.display != "none") {
                        if (!th.showOnUpdateOnly || (th.showOnUpdateOnly && pageData.unique_id)) {
                          let curval = row[th.field];

                          if (th.displaytype) {
                            curval = convertBoxValues(curval, th.displaytype, this);
                          }

                          if (this.state.editing[index] && th.field) {
                            return <td style={{ fontSize: 15, padding: 0 }} key={idx}>{this.getTableComponent({ th, index: idx, curval, rowid: index })}</td>;
                          } else if (th.type && th.type == 'autoinc') {
                            return <td style={{ fontSize: 15, padding: 0 }} key={idx}>{index + 1}</td>;
                          } else {
                            return <td style={{ fontSize: 15, padding: 0 }} key={idx}>{curval}</td>;
                          }
                        }
                      }
                    }
                    )}
                  </tr>
                ))}

              {addRows &&
                <tr><td style={{ fontSize: 15, padding: 0 }} colSpan={tableHeaders.length + (editable ? 1 : 0) + (deletable ? 1 : 0)}><span className="hand underline" onClick={() => this.handleAddRows(tableData)}>Add row</span></td></tr>
              }
            </tbody>
          </Table>

        </div>
      </div>
    );
  }
}

export default HtmlTableCustom;
